"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowIcon = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const theme_1 = require("../../constants/theme");
exports.ArrowIcon = styled_1.default.div(({ isOpen }) => ({
    appearance: 'none',
    backgroundImage: 'url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iIzAwMDAwMCI+CiAgICA8cGF0aCBkPSJNMjQgMjRIMFYwaDI0djI0eiIgZmlsbD0ibm9uZSIgb3BhY2l0eT0iLjg3IiAvPgogICAgPHBhdGggZD0iTTE2LjU5IDguNTlMMTIgMTMuMTcgNy40MSA4LjU5IDYgMTBsNiA2IDYtNi0xLjQxLTEuNDF6IiAvPgo8L3N2Zz4=)',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    height: 24,
    marginRight: 12,
    transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
    transition: theme_1.theme.animation.transition,
    width: 12,
}));
